"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendDelegateToArea = void 0;
var SelectPartyToSendDelegate_1 = require("../inputs/SelectPartyToSendDelegate");
var DeferredAction_1 = require("./DeferredAction");
var SelectHowToPayDeferred_1 = require("./SelectHowToPayDeferred");
var SendDelegateToArea = (function () {
    function SendDelegateToArea(player, title, options) {
        if (title === void 0) { title = 'Select where to send a delegate'; }
        if (options === void 0) { options = {}; }
        this.player = player;
        this.title = title;
        this.options = options;
        this.priority = DeferredAction_1.Priority.DEFAULT;
    }
    SendDelegateToArea.prototype.execute = function () {
        var _this = this;
        var turmoil = this.player.game.turmoil;
        if (turmoil === undefined) {
            throw new Error("Turmoil not defined in game " + this.player.game.id);
        }
        var parties = turmoil.parties;
        if (this.options.replace) {
            parties = turmoil.parties.filter(function (party) {
                if (party.delegates.length < 2)
                    return false;
                for (var _i = 0, _a = party.delegates; _i < _a.length; _i++) {
                    var delegate = _a[_i];
                    if (delegate !== _this.options.replace)
                        continue;
                    if (delegate !== party.partyLeader)
                        return true;
                    return party.delegates.filter(function (delegate) { return delegate === _this.options.replace; }).length > 1;
                }
                return false;
            });
        }
        else {
            parties = turmoil.parties;
        }
        var numDelegateToSend = this.options.count || 1;
        var availableParties = parties.map(function (party) { return party.name; });
        var sendDelegate = new SelectPartyToSendDelegate_1.SelectPartyToSendDelegate(this.title, 'Send delegate', availableParties, function (partyName) {
            if (_this.options.cost) {
                _this.player.game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(_this.player, _this.options.cost, { title: 'Select how to pay for send delegate action' }));
            }
            var source = _this.options.source || 'lobby';
            if (numDelegateToSend > 1 && source === 'lobby') {
                turmoil.sendDelegateToParty(_this.player.id, partyName, _this.player.game, 'lobby');
                for (var i = 0; i < numDelegateToSend - 1; i++) {
                    turmoil.sendDelegateToParty(_this.player.id, partyName, _this.player.game, 'reserve');
                }
            }
            else {
                for (var i = 0; i < numDelegateToSend; i++) {
                    if (_this.options.replace) {
                        turmoil.replaceDelegateFromParty(_this.options.replace, _this.player.id, source, partyName, _this.player.game);
                    }
                    else {
                        turmoil.sendDelegateToParty(_this.player.id, partyName, _this.player.game, source);
                    }
                }
            }
            _this.player.game.log('${0} sent ${1} delegate(s) in ${2} area', function (b) { return b.player(_this.player).number(numDelegateToSend).party(turmoil.getPartyByName(partyName)); });
            return undefined;
        });
        return sendDelegate;
    };
    return SendDelegateToArea;
}());
exports.SendDelegateToArea = SendDelegateToArea;
//# sourceMappingURL=SendDelegateToArea.js.map